<div class="landing-page">
    <!-- Topbar -->
    <header class="landing-topbar surface-0 shadow-2 px-4 md:px-6 lg:px-8">
        <div class="landing-container flex align-items-center justify-content-between py-3">
            <div class="flex align-items-center gap-3">
                <img src="assets/layout/images/sf-logoTabellio.png" alt="Cartório Fácil Online" height="44" />
                <div class="text-xl font-semibold">
                    <span class="text-900">Cartório Fácil</span>
                    <span class="text-orange-500">Online</span>
                </div>
            </div>

            <a class="cursor-pointer block lg:hidden text-700" pStyleClass="@next" enterClass="hidden" enterActiveClass="fadein" leaveToClass="hidden" leaveActiveClass="fadeout">
                <i class="pi pi-bars text-3xl"></i>
            </a>

            <div class="landing-menu-mobile hidden lg:hidden pb-4 border-top-1 surface-border">
                <button pButton pRipple class="p-button-text w-full justify-content-start" label="Serviços" (click)="scrollTo('servicos')"></button>
                <button pButton pRipple class="p-button-text w-full justify-content-start" label="Planos" (click)="scrollTo('planos')"></button>
                <button pButton pRipple class="p-button-text w-full justify-content-start" label="Contato" (click)="scrollTo('contato')"></button>
                <button pButton pRipple class="p-button-outlined w-full justify-content-start" icon="pi pi-user" label="Login" (click)="navigateToLogin()"></button>
                <button pButton pRipple class="w-full justify-content-start" icon="pi pi-user-plus" label="Criar conta" (click)="onPrimaryCta()"></button>
            </div>

            <div class="landing-menu hidden lg:flex align-items-center gap-4">
                <button pButton pRipple class="p-button-text" label="Serviços" (click)="scrollTo('servicos')"></button>
                <button pButton pRipple class="p-button-text" label="Planos" (click)="scrollTo('planos')"></button>
                <button pButton pRipple class="p-button-text" label="Contato" (click)="scrollTo('contato')"></button>
                <button pButton pRipple class="p-button-outlined" icon="pi pi-user" label="Login" (click)="navigateToLogin()"></button>
                <button pButton pRipple icon="pi pi-user-plus" label="Criar conta" (click)="onPrimaryCta()"></button>
            </div>
        </div>
    </header>

    <!-- Hero Start -->
    <section class="software-hero-section bg-half-260 d-table w-100 position-relative">
        <div class="bg-overlay"></div>
        <div class="landing-container position-relative" style="z-index: 1;">
            <div class="grid align-items-center mt-5">
                <div class="col-12 md:col-6">
                    <div class="title-heading mt-4 text-center md:text-left">
                        <h3 class="heading mb-3 text-white">Resolva assuntos de cartório sem filas, sem confusão e sem perder tempo.</h3>
                        <p class="para-desc text-white-50 text-xl">Escolha o cartório mais próximo, envie seus documentos online, acompanhe cada etapa e fale direto com o responsável pelo seu pedido.</p>
                        <div class="mt-4">
                            <button pButton pRipple icon="pi pi-user-plus" iconPos="left" label="Criar conta gratuita" class="p-button-lg" (click)="onPrimaryCta()"></button>
                        </div>
                    </div>
                </div>

                <div class="col-12 md:col-6 mt-4 pt-2">
                    <div class="position-relative">
                        <div class="software-hero-image">
                            <img src="assets/images/landing/saas/modern-hero.jpg" class="img-fluid d-block" alt="Cartório Fácil Online" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="position-relative">
            <div class="shape overflow-hidden text-color-white">
                <svg viewBox="0 0 2880 250" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M720 125L2160 0H2880V250H0V125H720Z" fill="currentColor"></path>
                </svg>
            </div>
        </div>
    </section>
    <!-- Hero End -->

    <!-- Section Start -->
    <section class="section pt-md-4 pt-5">
        <!-- Start Features -->
        <div class="landing-container">
            <div class="grid justify-content-center">
                <div class="col-12 text-center">
                    <div class="section-title mb-4 pb-2">
                        <h4 class="title mb-4">Você resolve com clareza, rapidez e controle</h4>
                        <p class="text-muted para-desc mx-auto mb-0">A tecnologia só facilita — a execução e a validação final continuam sendo feitas pelo cartório parceiro.</p>
                    </div>
                </div>
            </div>

            <div class="grid">
                <div class="col-12 md:col-6 lg:col-4 mt-5 pt-4" *ngFor="let benefit of benefits">
                    <div class="features feature-primary text-center">
                        <div class="image position-relative d-inline-block">
                            <i [class]="benefit.icon + ' h2 text-orange-500'"></i>
                        </div>
                        <div class="content mt-4">
                            <h5>{{ benefit.title }}</h5>
                            <p class="text-muted mb-0">{{ benefit.description }}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="grid justify-content-center mt-5 pt-4">
                <div class="col-lg-10 col-md-12">
                    <div class="alert alert-light alert-pills shadow text-dark text-center" role="alert">
                        <span class="badge rounded-pill bg-orange-500 me-2">Confiança</span>
                        <span class="content">Serviço executado pelo cartório parceiro <i class="pi pi-building ms-2"></i></span>
                    </div>
                </div>
            </div>
        </div>
        <!-- End Features -->

        <!-- CTA Card -->
        <div class="landing-container mt-100 mt-60">
            <div class="card rounded bg-light shadow border-0">
                <div class="card-body">
                    <div class="grid align-items-center">
                        <div class="col-12 md:col-7">
                            <div class="text-center md:text-left">
                                <h5 class="mb-0">Comece sem custo e resolva seu pedido com mais clareza</h5>
                            </div>
                        </div>
                        <div class="col-12 md:col-5 mt-4 md:mt-0">
                            <div class="text-center md:text-right">
                                <button pButton pRipple icon="pi pi-user-plus" iconPos="left" label="Criar conta gratuita" (click)="onPrimaryCta()"></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- CartórIA Section -->
        <div class="landing-container mt-100 mt-60">
            <div class="grid align-items-center">
                <div class="col-12 md:col-5">
                    <img src="assets/images/landing/saas/classic02.png" class="img-fluid" alt="CartórIA" />
                </div>

                <div class="col-12 md:col-7 mt-4 mt-sm-0 pt-2 pt-sm-0">
                    <div class="section-title ms-lg-5">
                        <h4 class="title mb-4">CartórIA — sua assistente de cartório</h4>
                        <p class="text-muted">CartórIA é a assistente inteligente que guia você em cada etapa do processo cartorial, evitando erros, atrasos e deslocamentos desnecessários.</p>
                        <ul class="list-none mb-0 text-muted">
                            <li class="mb-1"><span class="text-orange-500 h5 me-2"><i class="pi pi-check-circle align-middle"></i></span>Tira dúvidas em linguagem simples</li>
                            <li class="mb-1"><span class="text-orange-500 h5 me-2"><i class="pi pi-check-circle align-middle"></i></span>Verifica documentos automaticamente (legibilidade e itens obrigatórios)</li>
                            <li class="mb-1"><span class="text-orange-500 h5 me-2"><i class="pi pi-check-circle align-middle"></i></span>Reduz erros que geram retrabalho</li>
                            <li class="mb-1"><span class="text-orange-500 h5 me-2"><i class="pi pi-check-circle align-middle"></i></span>Acelera o fluxo com automações</li>
                        </ul>
                        <div class="mt-3 p-3 bg-orange-50 border-round border-left-3 border-orange-500">
                            <strong>Importante:</strong> a decisão final e a execução do serviço continuam sendo realizadas pelo cartório parceiro.
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Price Start -->
        <div class="landing-container mt-100 mt-60">
            <div class="grid justify-content-center">
                <div class="col-12 text-center">
                    <div class="section-title mb-4 pb-2">
                        <h4 class="title mb-4">Escolha seu plano ideal</h4>
                        <p class="text-muted para-desc mb-0 mx-auto">Comece sem custo. Escale conforme sua necessidade.</p>
                    </div>
                </div>
            </div>

            <div class="grid">
                <div class="col-12 md:col-6 lg:col-4 mt-4 pt-2">
                    <div class="card pricing pricing-primary business-rate shadow bg-light border-0 rounded">
                        <div class="card-body">
                            <h6 class="title name fw-bold text-uppercase mb-4">Cliente final</h6>
                            <div class="d-flex mb-4">
                                <span class="h4 mb-0 mt-2">R$</span>
                                <span class="price h1 mb-0">0</span>
                                <span class="h4 align-self-end mb-1">/mês</span>
                            </div>
                            <ul class="list-none mb-0 ps-0">
                                <li class="h6 text-muted mb-0"><span class="icon h5 me-2"><i class="pi pi-check-circle text-orange-500 align-middle"></i></span>Conta gratuita</li>
                                <li class="h6 text-muted mb-0"><span class="icon h5 me-2"><i class="pi pi-check-circle text-orange-500 align-middle"></i></span>Solicitação e acompanhamento</li>
                                <li class="h6 text-muted mb-0"><span class="icon h5 me-2"><i class="pi pi-check-circle text-orange-500 align-middle"></i></span>Chat com atendente responsável</li>
                                <li class="h6 text-muted mb-0"><span class="icon h5 me-2"><i class="pi pi-check-circle text-orange-500 align-middle"></i></span>Orientações pela CartórIA</li>
                            </ul>
                            <button pButton pRipple class="w-full mt-4" label="Criar conta gratuita" (click)="onPrimaryCta()"></button>
                        </div>
                    </div>
                </div>

                <div class="col-12 md:col-6 lg:col-4 mt-4 pt-2">
                    <div class="card pricing pricing-primary business-rate shadow border-0 rounded pricing-featured">
                        <div class="ribbon ribbon-right ribbon-warning overflow-hidden"><span class="text-center d-block shadow small h6">Mais escolhido</span></div>
                        <div class="card-body">
                            <h6 class="title name fw-bold text-uppercase mb-4">Despachante</h6>
                            <div class="d-flex mb-4">
                                <span class="h4 mb-0 mt-2">R$</span>
                                <span class="price h1 mb-0">15</span>
                                <span class="h4 align-self-end mb-1">/mês</span>
                            </div>
                            <ul class="list-none mb-0 ps-0">
                                <li class="h6 text-muted mb-0"><span class="icon h5 me-2"><i class="pi pi-check-circle text-orange-500 align-middle"></i></span>Múltiplos clientes no mesmo painel</li>
                                <li class="h6 text-muted mb-0"><span class="icon h5 me-2"><i class="pi pi-check-circle text-orange-500 align-middle"></i></span>Organização por pedidos e prazos</li>
                                <li class="h6 text-muted mb-0"><span class="icon h5 me-2"><i class="pi pi-check-circle text-orange-500 align-middle"></i></span>Checklists e validação assistida</li>
                                <li class="h6 text-muted mb-0"><span class="icon h5 me-2"><i class="pi pi-check-circle text-orange-500 align-middle"></i></span>Atendimento centralizado</li>
                            </ul>
                            <button pButton pRipple class="w-full mt-4" label="Assinar plano" (click)="onPrimaryCta()"></button>
                        </div>
                    </div>
                </div>

                <div class="col-12 md:col-6 lg:col-4 mt-4 pt-2">
                    <div class="card pricing pricing-primary business-rate shadow bg-light border-0 rounded">
                        <div class="card-body">
                            <h6 class="title name fw-bold text-uppercase mb-4">Cartório parceiro</h6>
                            <div class="d-flex mb-4">
                                <span class="price h1 mb-0">Sob consulta</span>
                            </div>
                            <ul class="list-none mb-0 ps-0">
                                <li class="h6 text-muted mb-0"><span class="icon h5 me-2"><i class="pi pi-check-circle text-orange-500 align-middle"></i></span>Gestão online de pedidos e prazos</li>
                                <li class="h6 text-muted mb-0"><span class="icon h5 me-2"><i class="pi pi-check-circle text-orange-500 align-middle"></i></span>Painel de atendimento</li>
                                <li class="h6 text-muted mb-0"><span class="icon h5 me-2"><i class="pi pi-check-circle text-orange-500 align-middle"></i></span>Automação e agentes para otimizar processos</li>
                                <li class="h6 text-muted mb-0"><span class="icon h5 me-2"><i class="pi pi-check-circle text-orange-500 align-middle"></i></span>Rastreabilidade e relatórios</li>
                            </ul>
                            <button pButton pRipple class="p-button-outlined w-full mt-4" label="Quero ser parceiro" (click)="scrollTo('contato')"></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Price End -->
    </section>
    <!-- section End -->

    <!-- Final CTA Section -->
    <section class="section bg-light">
        <div class="landing-container">
            <div class="grid justify-content-center">
                <div class="col-12 text-center">
                    <div class="section-title">
                        <h4 class="title mb-4">Comece sem custo e resolva seu pedido com mais clareza</h4>
                        <p class="text-muted para-desc mx-auto mb-0">Crie sua conta gratuita e veja como é simples acompanhar tudo em um só lugar.</p>
                        <div class="mt-4 pt-2">
                            <button pButton pRipple icon="pi pi-user-plus" iconPos="left" label="Criar conta gratuita" class="p-button-lg" (click)="onPrimaryCta()"></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Footer -->
    <footer class="landing-footer surface-900 text-100 px-4 py-6 md:px-6 lg:px-8">
        <div class="landing-container grid align-items-center">
            <div class="col-12 md:col-6">
                <div class="flex align-items-center gap-3">
                    <img src="assets/layout/images/sf-logoTabellio.png" alt="Cartório Fácil Online" height="36" />
                    <span class="text-sm">Processos mais rápidos, com transparência e suporte.</span>
                </div>
            </div>
            <div class="col-12 md:col-6 text-left md:text-right mt-4 md:mt-0">
                <span class="text-sm">© {{ currentYear }} • Serviço executado pelo cartório parceiro • Política de privacidade</span>
            </div>
        </div>
    </footer>
</div>
